import { createContext } from "react";
var TabContext = /* @__PURE__ */ createContext({});
var TabTriggerMapContext = /* @__PURE__ */ createContext({});
var TabsDescriptorsContext = /* @__PURE__ */ createContext({});
var TabsNavigatorContext = /* @__PURE__ */ createContext(null);
var TabsStateContext = /* @__PURE__ */ createContext({
  type: "tab",
  preloadedRouteKeys: [],
  history: [],
  index: -1,
  key: "",
  stale: false,
  routeNames: [],
  routes: []
});
export {
  TabContext,
  TabTriggerMapContext,
  TabsDescriptorsContext,
  TabsNavigatorContext,
  TabsStateContext
};
//# sourceMappingURL=TabContext.js.map
